import styles from "./styles.module.scss";
import { Body } from "./body/body";

export function TableSkeleton() {
  return (
    <div className={styles.container}>
      <Body />
    </div>
  );
}
